<div class="pane {{positionY}}-{{positionX}}" [ngClass]="{ 'positioned' : positioned }"
	(mouseover)="hoverIn()" (mouseleave)="hoverOut()">
	<span [innerHTML]="contents"></span>
	<span [hidden]="!link">
		<br />
		<br />
		<a [href]="link" target="_blank">{{ 'READ_MORE' | translate }}</a>
	</span>
</div>
